interface ToastProps {
  message: string;
  visible: boolean;
}

export default function Toast({ message, visible }: ToastProps) {
  return (
    <div
      className={`fixed bottom-24 md:bottom-8 left-1/2 -translate-x-1/2 z-[60] transition-all duration-300 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"
      }`}
      role="status"
      aria-live="polite"
    >
      <div className="flex items-center gap-2 rounded-full bg-foreground-950 text-background-50 px-4 py-2.5 text-sm whitespace-nowrap">
        <i className="ri-checkbox-circle-fill text-accent-400" />
        {message}
      </div>
    </div>
  );
}